import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'
// import ZoomOutIcon from '@material-ui/icons/ZoomOut'
import BottomBarButton from '../BottomBar/BottomBarButton'
import RemoveIcon from '@material-ui/icons/Remove'
import {
  ZOOM_FACTOR,
  modeSelector,
  MODE,
  zoomAtGlobalPoint,
  getGlobalCenter
} from '../../modules/reducerRotator'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const RotatorZoomOutButton = (props) => {
  // const classes = useStyles()
  const mode = useSelector(modeSelector)
  const canvasCenter = useSelector(getGlobalCenter)
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(zoomAtGlobalPoint(1 - ZOOM_FACTOR, canvasCenter))
  }, [dispatch, canvasCenter])

  return (
    <BottomBarButton
      {...props}
      tooltip="Alejar"
      tooltipEnabled={true}
      onClick={handleClick}
      disabled={mode === MODE.PANNING || mode === MODE.ROT_MOUSE}
    >
      <RemoveIcon fontSize="inherit" />
    </BottomBarButton>
  )
}
export default RotatorZoomOutButton
